import { DOP_CONFIG } from '../config/dopConfig';

const Step1Standard = ({ formData, setFormData }: any) => {

    const update = (field: string, value: any) => {
        setFormData((prev: any) => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <div>

            <h4 className="mb-5">Odaberi standard</h4>

            {/* STANDARD */}
            <div className="mb-10">
                <select
                    className="form-select"
                    value={formData.standard || ''}
                    onChange={(e) => update('standard', e.target.value)}
                >
                    <option value="">-- Odaberi --</option>

                    {DOP_CONFIG.standards.map((s) => (
                        <option key={s.value} value={s.value}>
                            {s.label}
                        </option>
                    ))}
                </select>
            </div>

            {/* PRIVREMENI DOP TOGGLE */}
            <div className="form-check form-switch mt-5 mb-4">
                <input
                    className="form-check-input"
                    type="checkbox"
                    id="privremeniDop"
                    checked={formData.privremeniDop || false}
                    onChange={(e) => update('privremeniDop', e.target.checked)}
                />
                <label className="form-check-label fw-semibold" htmlFor="privremeniDop">
                    Privremeni DOP
                </label>
            </div>

            {/* CONDITIONAL FIELDS */}
            {formData.privremeniDop && (
                <div className="row g-4">

                    <div className="col-md-6">
                        <label>Broj naloga</label>
                        <input
                            type="text"
                            className="form-control"
                            value={formData.brojNaloga || ''}
                            onChange={(e) => update('brojNaloga', e.target.value)}
                        />
                    </div>

                    <div className="col-md-6">
                        <label>Stavka</label>
                        <input
                            type="text"
                            className="form-control"
                            value={formData.stavka || ''}
                            onChange={(e) => update('stavka', e.target.value)}
                        />
                    </div>

                </div>
            )}

        </div>
    );
};

export default Step1Standard;